export const iconFontAwesomeWeatherCloudMoon = (
	<i className="fa-solid fa-cloud-moon"></i>
);
